import styled from "styled-components";

import PageWrapper from "Components/Pages/Wrapper";
import { Form } from "formik";

export const PageContainer = styled(PageWrapper)`
  padding-top: 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;

  .page-heading {
    flex-wrap: nowrap;
  }

  & > .separator {
    width: 100%;
    border-bottom: 1px solid #cccccc;
    margin: 30px 0;
  }

  .budget-detailed,
  .page-heading {
    padding: 0 40px;
  }
`;

export const MainContent = styled.div`
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
`;

export const CampFile = styled.div`
  margin-top: 5px;
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 0px 0px 1px rgba(130, 136, 148, 0.16),
    0px 4px 6px -2px rgba(130, 136, 148, 0.32);
  border-radius: 10px;
  padding: 20px 40px;
  align-self: start;
  box-sizing: border-box;

  label {
    margin: 0;
    width: 100%;
  }

  img {
    max-width: 109px;
    max-height: 96px;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 168px;
  }
`;

export const ScheduleContainer = styled(Form)`
  .input-field {
    width: 100%;
    max-width: 600px;
    margin-bottom: 20px;
  }

  .schedule {
    h1 {
      font-size: 1.8rem;
      color: var(--color-purple);
      margin: 0;
    }

    h2 {
      font-size: 1.4rem;
      color: var(--color-purple);
      margin: 0;
      font-weight: 600;
    }
  }

  .personal-info,
  .address-info {
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 1.8rem;
      color: var(--color-purple);
    }
  }

  .address-info {
    margin-bottom: 20px;
  }

  .fields-container {
    display: flex;
    flex-wrap: wrap;

    & > div {
      margin-bottom: 10px;
    }
  }

  .upload-file {
    display: flex;
    flex-direction: column;
    align-items: end;
    width: 350px;
    margin-bottom: 36px;
    padding: 0 8px;
    margin-top: 20px;

    label {
      width: 100%;
    }

    .invalid {
      background-color: rgba(224, 159, 157, 0.25);
      border: 1px solid #c23f3b;
    }
  }

  .preview-imgs {
    max-height: 430px;
    display: flex;
    gap: 5px;
    flex-wrap: wrap;

    .preview-img {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    img {
      height: 350px;
      width: 200px;
    }

    button {
      padding: 0;
    }

    .icon {
      width: 15px;
      height: 15px;
    }
  }
`;

export const SelectScheduleContainer = styled.div`
  .datetime-result-list {
    margin-top: 30px;
  }

  .container-dates-options.container-times-options {
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
    box-sizing: border-box;
  }

  .container-times-options {
    margin-top: 30px;
  }

  .available-months {
    margin-top: 30px;
  }

  .error {
    margin-top: 30px;
  }

  .dates-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }

  .text-md {
    font-size: 1.5rem;
  }
`;

export const Container = styled.div`
  width: 100%;

  .text-md {
    font-size: 1.3rem;
  }

  .message-success {
    max-width: 450px;
    margin: 0 auto;
    text-align: center;
  }

  .schedule-sec {
    margin-top: 60px;
  }

  .scheduleinfo {
    font-size: 1rem;
  }
`;

export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;

  .search-bar {
    display: flex;
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
    margin-top: 100px;
    position: relative;

    .field-holder {
      flex: 1;

      input {
        border-radius: 8px 0 0 8px;
        border: 1px solid var(--color-purple);
      }
    }

    button {
      height: auto;
      position: relative;
      border-radius: 0 30px 30px 0;
      font-size: 1rem;
    }
  }

  ,
  .wrapper-loading {
    margin-top: 20px;
  }

  .wrap-text {
    width: 100%;
    max-width: 450px;
    margin: 20px auto 0;
  }
`;
